export default __webpack_public_path__ + "static/media/baseline-signal_wifi_1_bar-24px.68b27f88.svg";